import {VehicleTypeEnumObject} from '@dms/api/shared';

export type VehicleSeriesDefinitionRequestBody = {
  /**
   * Definition name
   */
  name: string;
  /**
   * ID of existed series
   */
  seriesId: string;
  /**
   * ID of existed Branch. If is not provided then definition is valid for whole Tenant
   */
  branchId: string | null;
  vehicleType: VehicleTypeEnumObject;
  /**
   * To which makes will be definition applied
   */
  makes: Array<string> | null;
};
